import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericEditorEventProvider } from '../../../GenericEditorStateProvider';
import { EntityPickerField } from '../../../models/Field';

@Component({
  selector: 'entity-picker',
  template: `<div [formGroup]="form" class="form-group">
    <label style="display: block;">{{ field.label }}</label>
    <input
      [formControlName]="field.key"
      type="hidden"
      id="{{ field.key }}"
      name="{{ field.key }}"
    />
    <div
      style="display: flex; max-width: 100%;"
      [style.width]="field.size ? field.size + 1 + 'em' : ''"
    >
      <button
        disabled=""
        class="form-control btn btn-default"
        type="button"
        [ngClass]="
          control.invalid && control.touched ? 'ng-invalid ng-touched' : ''
        "
        style="overflow: hidden; text-overflow: ellipsis;"
        [style.text-align]="field.textAlign"
      >
        {{ control.value ? control.value : 'pick an item' }}
      </button>
      <button
        *ngIf="control.value"
        [disabled]="!control.value"
        (click)="handleOpenDetails()"
        type="button"
        class="btn btn-default form-control"
        style="width: auto; padding: 6px 12px;"
      >
        D
      </button>
      <button
        [disabled]="field.isLocked || form.disabled"
        type="button"
        class="btn btn-default form-control"
        style="width: auto; padding: 6px 12px;"
        (click)="handlePickerClick()"
      >
        {{ control.value ? 'X' : '. . .' }}
      </button>
    </div>
    <error-box [form]="form" [field]="field"></error-box>
  </div>`,
})
export class EntityPickerComponent {
  @Input() form: FormGroup;
  @Input() field: EntityPickerField;
  @Input() metadataName: string = 'ClientContacts'; // default value for testing

  isDetailsVisible: boolean = false;
  isGridVisible: boolean = false;

  constructor(public eventProvider: GenericEditorEventProvider) { }

  get control() {
    return this.form.controls[this.field.key];
  }

  handlePickerClick() {
    if (this.control.value) {
      this.control.setValue(null);
      this.control.markAsTouched();
      this.control.markAsDirty();
    } else {
      this.eventProvider.emit({
        name: 'OPEN_ENTITY_SELECTOR',
        value: { metadataName: this.metadataName, fieldKey: this.field.key },
      });
    }
  }

  handleOpenDetails() {
    this.eventProvider.emit({
      name: 'OPEN_ENTITY_DETAILS',
      value: { metadataName: this.metadataName, id: this.control.value },
    });
  }

  ngOnInit() {
    this.eventProvider.on(
      'ENTITY_SELECTED',
      (({ id, fieldKey }) => {
        if (this.field.key === fieldKey) {
          this.control.setValue(id);
          this.control.markAsTouched();
          this.control.markAsDirty();
        }
      }).bind(this)
    );
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/fields/entity-picker/entity-picker.component.ts